import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { Tabs as ReactTabsRoot, TabList, Tab, TabPanel } from "react-tabs";
import styles from "./Tabs.module.css";

/**
 * Tabs
 * @type React.FC<TabsPropTypes>
 */
const Tabs = React.forwardRef((props, ref) => {
  Object.keys(props).forEach((p) => {
    if (!Object.keys(TabsPropTypes).includes(p)) {
      console.error(`Tabs: 정의되지 않은 prop ${p}가 전달되었습니다.`);
    }
  });

  /** 외부에서 접근할 수 있는 함수들 */
  React.useImperativeHandle(ref, () => ({
    setSelectedIndex(index) {
      setCurrState((prev) => ({
        ...prev,
        selectedIndex: index,
      }));
    },

    getSelectIndex() {
      return currState.selectedIndex;
    },
  }));

  const [currState, setCurrState] = useState({
    selectedIndex: props.selectedIndex ?? 0,
  });

  const tabHeaders = [];
  const tabPanels = [];
  for (let i = 0; i < props.tabs?.length; i++) {
    tabHeaders.push(
      <Tab key={`tab_header_${i}`} className={styles.tabHeader} selectedClassName={styles.tabHeaderSelected}>
        {props.tabs[i].header}
      </Tab>
    );
    tabPanels.push(
      <TabPanel key={`tab_panel_${i}`} className={styles.tabPanel} selectedClassName={styles.tabPanelSelected}>
        {props.tabs[i].content}
      </TabPanel>
    );
  }

  const refTabPanel = useRef();

  const selectedIndexChanged = (index) => {
    setCurrState((prev) => ({
      ...prev,
      selectedIndex: index,
    }));
  };

  return (
    <ReactTabsRoot
      ref={refTabPanel}
      className={styles.tabsBelow}
      selectedIndex={currState.selectedIndex}
      onSelect={(index) => selectedIndexChanged(index)}
      forceRenderTabPanel
    >
      <TabList className={styles.tabHeaders}>{tabHeaders}</TabList>
      {tabPanels}
    </ReactTabsRoot>
  );
});

const TabsPropTypes = {
  children: PropTypes.node,
  selectedIndex: PropTypes.number,
  tabs: PropTypes.array,
};
Tabs.propTypes = TabsPropTypes;
Tabs.defaultProps = {
  selectedIndex: 0,
};
Tabs.displayName = "Tabs";

export default Tabs;
